export const resizeWithRatio = (file, targetWidth, targetHeight) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = (event) => {
            const img = new Image();
            img.onload = () => {
                const canvas = document.createElement("canvas");
                const ctx = canvas.getContext("2d");

                // ✅ 比率維持
                const scale = Math.min(targetWidth / img.width, targetHeight / img.height);
                const dw = img.width * scale;
                const dh = img.height * scale;

                canvas.width = dw;
                canvas.height = dh;

                // 描画
                ctx.drawImage(img, 0, 0, img.width, img.height, 0, 0, dw, dh);

                canvas.toBlob((blob) => {
                    const url = URL.createObjectURL(blob);
                    resolve({ url, width: dw, height: dh });
                }, "image/png");
            };

            img.onerror = () => reject(new Error("画像読み込みエラー"));
            img.src = event.target.result;
        };

        reader.onerror = () => reject(new Error("ファイル読み込みエラー"));
        reader.readAsDataURL(file);
    });
};
